SlideView           = require("views/slide")
ScormAttempt        = require "models/scormAttempt"
{ Session, Lesson } = Application.actions()

class URLView extends SlideView
  template: require("./template")

  events: ->
    "iostap .exit-btn": "submit"

  beforeShow: ->
    position = @options.data.button?.position?.toLowerCase() or "below"
    @setState written.hyphenCase(position), "exit-btn"

    @trigger "ui",
      lightbox: @options.data.background or true
      flexible: true
      fullscreen: true

    @onResize()

  beforeHide: ->
    @trigger "ui", { lightbox: false, flexible: false, fullscreen: false }

  show: ->
    @listenTo this, "resize", @onResize

  onRefresh: ->
    @beforeShow()
    super

  onResize: ->
    if @currentState["exit-btn"] is "below"
      button = @findOne(".exit-btn")
      iframe = @findOne(".url-object")

      iframe.style.bottom = "#{button.offsetHeight}px"
      iframe.style.height =
        "#{iframe.parentNode.offsetHeight - button.offsetHeight}px"

module.exports = URLView
